if (!customElements.get('vbb-cart-min-quantity-upsell')) {
  customElements.define('vbb-cart-min-quantity-upsell', class CartMinQuantityUpsell extends HTMLElement {
    constructor() {
      super();
    }

    updateCart() {
      this.cart.setLoading();

      const upsellForm = new FormData();

      upsellForm.append('items[0][id]', this.dataset.variantId);
      upsellForm.append('items[0][quantity]', 1);
      upsellForm.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      upsellForm.append('sections_url', window.location.pathname);

      this.cart.setActiveElement(document.activeElement);

      const upsellFormConfig = fetchConfig('javascript');
      upsellFormConfig.headers['x-requested-with'] = 'XMLHttpRequest';
      delete upsellFormConfig.headers['Content-Type'];

      upsellFormConfig.body = upsellForm;

      fetch(routes.cart_add_url, upsellFormConfig)
        .then(response => response.json())
        .then(response => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vbb-product-form'
          });

          this.cart.renderContents(response);
        })
        .catch(e => console.error(e))
        .finally(() => {
          if (this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          this.cart.setNotLoading();
        });
    }

    connectedCallback() {
      this.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        this.updateCart()
      });

      this.cart = document.querySelector('cart-drawer');
    }
  });
}
